import { memo } from 'react';

import InsertRowBelowIconSVG from '@/assets/insert-row-below-icon.svg?react';
import { Icon, IconProps } from '@/components/core';

const IInsertRowBelowIcon = (props: Omit<IconProps, 'SVGComponent'>) => (
  <Icon SVGComponent={InsertRowBelowIconSVG} {...props} />
);

export const InsertRowBelowIcon = memo(IInsertRowBelowIcon) as typeof IInsertRowBelowIcon;
